<template>
  <div class="reactions-panel">
    <div class="reactions-panel__reactions">
      <div
        v-for="reaction in reacted"
        :key="reaction.name"
        class="reactions-panel__reaction-item"
      >
        <ReactionButton
          :href="fallbackHref"
          :reaction="reaction"
          @click="!fallbackHref && toggleReaction(reaction)"
        >
          {{ reaction.count }}
        </ReactionButton>
      </div>
      <div
        v-if="availableReactions.length !== 0"
        class="reactions-panel__reaction-item"
      >
        <BasicButton
          v-if="fallbackHref"
          :href="fallbackHref"
          appearance="reaction-toggle"
        >
          <SvgIcon icon="emoji-add" size="20" color="muted" />
        </BasicButton>
        <DropdownTarget
          v-else
          v-slot="{ visible, show, hide }"
        >
          <BasicButton
            appearance="reaction-toggle"
            @click="show"
          >
            <SvgIcon icon="emoji-add" size="20" color="muted" />
          </BasicButton>
          <TransitionFade>
            <BasicDropdown
              v-if="visible"
              placement="top"
              min-width="max"
            >
              <div class="reactions-panel__picker">
                <div
                  v-for="reaction in availableReactions"
                  :key="reaction.name"
                  class="reactions-panel__picker-item"
                >
                  <ReactionButton
                    appearance="reaction-toggle"
                    :reaction="reaction"
                    @click="toggleReaction(reaction); hide($event)"
                  />
                </div>
              </div>
            </BasicDropdown>
          </TransitionFade>
        </DropdownTarget>
      </div>
    </div>
  </div>
</template>

<script>
  import { modelValueConfig } from 'src/utils/vue.js';

  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import BasicDropdown from 'src/components/BasicDropdown/BasicDropdown.vue';
  import DropdownTarget from 'src/components/DropdownTarget/DropdownTarget.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import ReactionButton from 'src/components/reactions/ReactionButton/ReactionButton.vue';
  import TransitionFade from 'src/components/transitions/TransitionFade/TransitionFade.vue';

  export default {
    name: 'ReactionsPanel',
    components: { ReactionButton, SvgIcon, TransitionFade, BasicDropdown, DropdownTarget, BasicButton },
    model: modelValueConfig(),
    props: {
      modelValue: {
        type: Array,
        required: true,
      },
      fallbackHref: String,
    },
    methods: {
      toggleReaction(reaction) {
        const newList = this.modelValue.slice(0);
        const index = this.modelValue.indexOf(reaction);
        const hasReacted = !reaction.hasReacted;
        const count = hasReacted ? reaction.count + 1 : reaction.count - 1;
        const newReaction = {
          ...reaction,
          hasReacted,
          count,
        };
        newList.splice(index, 1, newReaction);

        this.$emit('update:modelValue', newList);
      },
    },
    computed: {
      reacted() {
        return this.modelValue.filter(reaction => reaction.count > 0);
      },
      availableReactions() {
        return this.modelValue.filter(reaction => !reaction.hasReacted);
      },
    }
  }
</script>